// import './util/check-device'
// import polyfill from './util/polyfill'
import vhCheck from 'vh-check'
import cssVars from 'css-vars-ponyfill'
import objectFitImages from 'object-fit-images'
window.addEventListener('load', () => {
	cssVars()
	objectFitImages()
	vhCheck({
		redefineVh: true,
		updateOnTouch: true
	})
})



// WEBPACK FOOTER //
// ./js/util.js